export default __webpack_public_path__ + "static/media/CNo.82-7.4b18ddf9.jpg";